import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { jsx } from '../../jsx';
import Geometry from '../geometry';
export default (function (View) {
  return /*#__PURE__*/function (_Geometry) {
    _inherits(Point, _Geometry);

    var _super = _createSuper(Point);

    function Point() {
      _classCallCheck(this, Point);

      return _super.apply(this, arguments);
    }

    _createClass(Point, [{
      key: "getDefaultCfg",
      value: function getDefaultCfg() {
        return {
          geomType: 'point'
        };
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        var coord = props.coord;
        var records = this.mapping();
        return jsx(View, _objectSpread(_objectSpread({}, props), {}, {
          coord: coord,
          records: records
        }));
      }
    }]);

    return Point;
  }(Geometry);
});